type Props = {
  className?: string;
};

const VideoIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.8" y="1.8" width="16.4" height="16.4" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M17.4915 7.87772L22.4915 4.66343C22.6246 4.57786 22.7996 4.67343 22.7996 4.83167V15.1683C22.7996 15.3266 22.6246 15.4221 22.4915 15.3366L17.4915 12.1223C17.4342 12.0855 17.3996 12.0221 17.3996 11.954V8.04595C17.3996 7.9779 17.4342 7.91452 17.4915 7.87772Z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
};

export default VideoIcon;
